import ClassNames from 'classnames'
import React from 'react'
import {
  GridBase
} from './../../base'
import { GridWrapper } from './styled'


/**
 * Grid description:
 * - 12 Columns system
 * - Breakpoints:
 *   - Mobile        (from screen to 413px)
 *   - Phablet       (min 414px)
 *   - Tablet        (min 768px)
 *   - Laptop        (min 1024px)
 *   - Desktop       (min 1366px)
 *   - Large Desktop (min 1600px)
 */

class GridResponsiveColumn extends React.PureComponent {
  render() {
    const {
      className,
      children,
      ui
    } = this.props

    // props for css classes
    const classes = ClassNames(
      className,
    )

    return (
      <React.Fragment>
        {(() => {
          switch (ui) {
            case 'fieldText':
              return (
                <GridWrapper.Column
                  {...this.props}
                  className={classes}
                  gridLaptop='12'
                  gridDesktop='5'
                  gridLargeDesktop='4'
                >
                  {children}
                </GridWrapper.Column>
              )
            case 'fieldPhone':
              return (
                <GridWrapper.Column
                  {...this.props}
                  className={classes}
                  gridLaptop='6'
                  gridDesktop='5'
                  gridLargeDesktop='4'
                >
                  {children}
                </GridWrapper.Column>
              )
            case 'fieldSelect':
              return (
                <GridWrapper.Column
                  {...this.props}
                  className={classes}
                  gridTablet='12'
                  gridLaptop='4'
                  gridLargeDesktop='3'
                >
                  {children}
                </GridWrapper.Column>
              )
            default:
              return (
                <GridWrapper.Column
                  {...this.props}
                  className={classes}
                >
                  {children}
                </GridWrapper.Column>
              )
          }
        })()}
      </React.Fragment>
    )
  }

  static Column = GridBase.Column

  static defaultProps = {
  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}

export class Grid extends React.PureComponent {
  render() {
    const {
      className
    } = this.props

    // props for css classes
    const classes = ClassNames(
      className,
    )

    return (
      <GridBase
        {...this.props}
        className={classes}
      />
    )
  }

  static Column = GridBase.Column
  static ResponsiveColumn = GridResponsiveColumn

  static defaultProps = {
  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}
